module.exports = __webpack_public_path__ + "static/media/1.26 FOTO 1.1e6e36cf.jpg";